// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2eee41eb","498":"acb7318c","513":"07d39078","787":"909fdc84"}[chunkId] + ".chunk.js";
};